import { Star, Quote } from "lucide-react";

const LOGOS = ["LakesideMarina", "AlpineGear", "RidgeRentals", "CoastalToursCo", "PeakPowersports", "MeridianEvents"];

const TESTIMONIALS = [
  {
    quote:
      "We replaced four tools with RentAnything in one summer. Saturday mornings stopped feeling like a fire drill.",
    author: "Sarah K.",
    role: "Owner, Lakeside Marina",
  },
  {
    quote:
      "Our team finally has one place for waivers, payments, and dispatch. Renters self-serve before they even arrive.",
    author: "Mike R.",
    role: "GM, Ridge Powersports",
  },
];

const METRICS = [
  { value: "10k+", label: "Bookings processed" },
  { value: "98%", label: "Operator retention" },
  { value: "12m", label: "Avg. checkout time saved per booking" },
];

export default function TrustStrip() {
  return (
    <section className="border-y border-ra-line bg-ra-paper" data-testid="trust-strip">
      <div className="ra-container py-14">
        {/* logos placeholder strip */}
        <p className="text-center text-xs font-semibold uppercase tracking-[0.22em] text-ra-ink/50">
          Trusted by operators across 6 verticals
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-10 gap-y-4 opacity-70">
          {LOGOS.map((l) => (
            <span
              key={l}
              className="font-display text-base font-semibold tracking-tight text-ra-ink/40"
            >
              {l.replace(/([A-Z])/g, " $1").trim()}
            </span>
          ))}
        </div>

        {/* testimonials + metrics */}
        <div className="mt-12 grid gap-6 lg:grid-cols-[1.4fr_1fr]">
          <div className="grid gap-4 sm:grid-cols-2">
            {TESTIMONIALS.map((t) => (
              <figure key={t.author} className="ra-card flex flex-col gap-3" data-testid={`testimonial-${t.author.split(" ")[0].toLowerCase()}`}>
                <Quote size={20} className="text-ra-ocean/60" />
                <blockquote className="text-sm leading-relaxed text-ra-ink/85">"{t.quote}"</blockquote>
                <figcaption className="mt-2 flex items-center gap-2 text-xs">
                  <span className="font-semibold text-ra-ink">{t.author}</span>
                  <span className="text-ra-ink/55">· {t.role}</span>
                  <span className="ml-auto flex items-center gap-0.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <Star key={i} size={11} className="fill-ra-amber text-ra-amber" />
                    ))}
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>

          <div className="grid grid-cols-3 gap-3 sm:gap-4">
            {METRICS.map((m) => (
              <div
                key={m.label}
                className="rounded-2xl border border-ra-line bg-white p-4 sm:p-5 text-center shadow-card"
                data-testid={`metric-${m.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              >
                <p className="font-display text-2xl sm:text-3xl font-semibold text-ra-ocean">{m.value}</p>
                <p className="mt-1 text-[11px] leading-snug text-ra-ink/65">{m.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
